import React from 'react';
import { BellIcon, UserIcon, LogOutIcon } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';
export function Header() {
  const {
    user,
    logout
  } = useAuth();
  const handleLogout = () => {
    logout();
    window.location.href = '/signin';
  };
  return <header className="bg-black border-b border-neutral-800" data-id="element-2156">
      <div className="flex justify-between items-center px-8 py-4" data-id="element-2157">
        <div className="flex items-center" data-id="element-2158">
          <img src="https://cdn.magicpatterns.com/uploads/dD2ky7sJeHjQciMffUZLzT/Accrue_logo_v2_(1)_(1).png" alt="Accrue" className="h-8 w-auto invert" data-id="element-2159" />
        </div>
        <div className="flex items-center space-x-2" data-id="element-2160">
          <button className="p-2 text-neutral-400 hover:text-white hover:bg-neutral-800 rounded-md transition-colors" data-id="element-2161">
            <BellIcon size={18} data-id="element-2162" />
          </button>
          <div className="relative group" data-id="element-2163">
            <button className="p-2 text-neutral-400 hover:text-white hover:bg-neutral-800 rounded-md transition-colors flex items-center gap-2" data-id="element-2164">
              <UserIcon size={18} data-id="element-2165" />
              <span className="hidden md:block text-sm font-medium text-neutral-300" data-id="element-2166">
                {user?.firstName || 'User'}
              </span>
            </button>
            <div className="absolute right-0 mt-1 w-48 bg-white rounded-md shadow-lg py-1 z-10 hidden group-hover:block border border-neutral-200" data-id="element-2167">
              <button onClick={handleLogout} className="flex items-center w-full px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50 transition-colors" data-id="element-2168">
                <LogOutIcon size={14} className="mr-2" data-id="element-2169" />
                Sign out
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>;
}